module.exports = __webpack_public_path__ + "media/images/icons/flags/PH-191b1ceeac7607d945b12d83694d0046.svg";